<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left">
        <span class="is-size-6">Est présent dans {{ sourceUserGroups.length }} groupe<span v-if="sourceUserGroups.length > 1">s</span></span>
      </div>
    </div>
    <table class="table is-fullwidth is-marginless is-last-fixed-medium has-cells-vcentered">
      <thead>
        <tr class="is-size-6">
          <th>Nom</th>
          <th></th>
        </tr>
      </thead>
      <tbody class="is-size-6">
        <tr
          v-for="group in sourceUserGroups"
          :key="group.pk"
          class="is-size-6">
          <td>
            <router-link :to="{name: 'GroupVue', params: {id: group.pk}}">
              {{ group.name }}
            </router-link>
          </td>
          <td class="has-text-centered actions">
            <display-button-list
              :buttons="groupButtonList"
              :data="group"></display-button-list>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserGroupesList',
  mixins: [],
  props: {
    propsTab: String,
    sourceUserGroups: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      groupButtonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'GroupVue', params: { id } })
          },
          icon: 'fa-eye'
        }
      ]
    }
  },
  methods: {
  }
}
</script>
